<template>
<div class="row">
    <div class="col-sm-12  col-md-6">
        <text-field label="Your Policy Number" :value.sync="data.policy_number" />
    </div>
    <div class="col-sm-12 col-md-6">
        <text-field label="Website Registration Key" :value.sync="data.registration_key" />
    </div>
</div>
</template>

<script>
import TextField from "@/components/Form/TextField.vue";

export default {
  name: "PostRegistrationRequiredFields",
  components: {
    TextField
  },
  props: ["data"]
};
</script>
